<template>
  <v-system-bar v-if="impersonate && impersonate.is_impersonating"
                height="40"
                app>
    <div class="mr-2">
      You are impersonating {{ user.name }} ({{ user.id }})
    </div>
    <v-btn :href="`/v2/admin/users/${user.id}}/leave`"
           x-small>
      Stop impersonation
    </v-btn>
  </v-system-bar>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'impersonate',
      'user',
    ])
  }
}
</script>
